import React from "react";
import { useTranslation } from "react-i18next";
import CampaignEditor from "../features/campaigns/CampaignEditor";

const CampaignEditorPage: React.FC = () => {
  const { t } = useTranslation();

  return <CampaignEditor />;
};

export default CampaignEditorPage;
